// extracted by mini-css-extract-plugin
export default {"open-img":"OpenImg_open-img__iV+MK","open-spn":"OpenImg_open-spn__8KpFn"};